// 提案希望 送付済か
export const getIsProposalRequested = (proposalRequestComment) => typeof proposalRequestComment === 'string';
